module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "FMH"
  }, [_c('span', {
    attrs: {
      "aria-label": "5",
      "id": "pg_5",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Making a Sustainable Kitchen")])])]), _vm._v(" "), _c('p', {
    staticClass: "fbm-quote"
  }, [_c('span', {
    staticClass: "serif"
  }, [_vm._v("The kitchen is the heart of our homes and finding ways to make it feel healthy and wholesome can be really important.")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_c('samp', {
    staticClass: "SANS_Milliard_ExtraLight_229"
  }, [_vm._v("From leftover food scraps to the endless packaging that our food comes in, there’s so much that goes on in a kitchen - it’s probably the place in our homes where we generate the most waste. We can’t tackle everything in one little book, so we won’t be focussing on food waste or edible things, but we can help you to think of crafty solutions to help your kitchen become closer to zero waste.")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_c('samp', {
    staticClass: "SANS_Milliard_ExtraLight_229"
  }, [_vm._v("In the main, these projects use classic craft skills like sewing and crochet, with a pinch of cutting, sticking and drilling thrown in for good measure. Learning how to do little bits of everything can become your toolkit to thinking creatively about how you can reuse everyday things, helping you towards a zero waste lifestyle.")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_c('samp', {
    staticClass: "SANS_Milliard_ExtraLight_229"
  }, [_vm._v("Enjoy the journey!")])]), _vm._v(" "), _c('figure', {
    staticClass: "IMGL"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "120",
      "src": "images/pg5.jpg",
      "width": "372"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6026974a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/making_sustainable.vue
// module id = 69
// module chunks = 0